









































































































































































































































































import {Vue, Component} from 'vue-property-decorator';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import {getFirstAndEndDay, getToday, addMonth} from '@/utils/dateUtils';
import {formatCurrency} from '@/utils/formatUtils';
import ItemTable from '@/components/common/ItemTable.vue';
import AdItemTable from '@/views/statistic/promotion/AdItemTable.vue';
import CartItemTable from '@/views/statistic/promotion/coupons/CartItemTable.vue';
import ClickOutside from 'vue-click-outside';
import {namespace} from 'vuex-class';
import {i18nInObjectList} from '@/utils/i18n';
import TuiGrid from 'tui-grid';
import $ from 'jquery';
import {DEFAULT_DATE_RANGE, DEFAULT_TIME_RANGE} from '@/pro/components/common/datepicker/dateRange'
import {PARTNERS_SEARCH_TYPE, PARTNERS_STATUS} from '@/views/statistic/common/getPartners'

import PageBottomContent from '@/components/board/common/PageBottomContent.vue';
import {
  Mall,
  Grade,
  Group,
  Partner,
  GetStatisticsPromotionsCouponsRequest, GetPartnersRequest,
} from 'supporter';
import {createExcel} from '@/components/common/grid/ExcelCreateUtil';
import debounce from 'lodash.debounce';
import BrandSearcher from '@/components/product/BrandSearcher.vue';

const mallModule = namespace('mall');

@Component({
  components: {
    CompRadioButton,
    PeriodDateCalendar,
    CompSelectBox,
    PageBottomContent,
    CompCheckBox,
    ItemTable,
    AdItemTable,
    CartItemTable,
    BrandSearcher
  },
  directives: {
    ClickOutside
  }
})
export default class ProducAndCartCoupon extends Vue {
  // 쇼핑몰
  @mallModule.Getter('mallsGlobal') private malls!: Mall[];
  private get mallList() {
    const list: any = [];
    if (this.malls) {
      this.malls.forEach((mall) => {
        if (mall.used) {
          list.push({
            value: mall.mallNo.toString(),
            name: mall.mallName
          });
        }
      });
    }
    return list;
  }

  private contentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    name: 'gridProductCoupon',
    onLoadSearch: false,
  };
  private cartContentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    name: 'gridCartCoupon',
    onLoadSearch: false,
  };
  private useNaverPay: boolean = false;
  private summaryContentBottomOption = {};
  private productCouponsSummary: any = [];
  private cartCouponsSummary: any = [];
  private totalCount: number = 0;
  private cartCouponsContents: any = [];
  private productCouponsContents: any = [];
  private displayGrid = false;
  private retStartYmd: string = '';
  private retYear: string = '';
  private retMonth: string = '';
  private retDateType: string = '';
  private retEndYmd: string = '';
  private retMallName: string = '';
  private retPartnerName: string = '';
  private retPartnerNo: string = '';
  private retBrandName: string = '';

  private partnerResult: any[] = [];
  private selectedPartner: any = {};
  private showResult: boolean = false;
  private partnerName: string = '';
  private partners: Partner[] = [];
  private searchPartner = debounce((e:Event) => this.searchPartnerByKeyword(e), 500);
  private async searchPartnerByKeyword(e) {
    const value = (e.target as HTMLInputElement).value;

    if (this.getStatisticsPromotionsCouponsRequest.params.mallNo === undefined) {
      alert(this.$t('COMMON_ERR_MALLNO_NULL'));
      this.$emit('focusMallNo');
    } else {
      const isSelectedPartner = value === this.selectedPartner?.targetName;
      if(!value) {
        this.partnerReset();
        return;
      }
      if (isSelectedPartner) return;
      
      const request : GetPartnersRequest = {
        params: {
          searchType: PARTNERS_SEARCH_TYPE.partnerName,
          keyword: value,
          mallNo: Number(this.getStatisticsPromotionsCouponsRequest.params.mallNo),
          startDateTime: `${DEFAULT_DATE_RANGE.MIN} ${DEFAULT_TIME_RANGE.START}`,
          endDateTime: `${DEFAULT_DATE_RANGE.MAX} ${DEFAULT_TIME_RANGE.END}`,
          partnerStatus: PARTNERS_STATUS.active,
          contractStatuses: PARTNERS_STATUS.active + ',' + PARTNERS_STATUS.suspend,
        }
      };
      const { data } = await this.$api.getPartners(request)
      this.partners = data.contents;

      this.partnerName = value;
      this.partnerResult = [];
      this.selectedPartner = null;
      this.showResult = true;

      const filteredPartnerName = this.partners.filter(({partnerName}) => (
        partnerName.replace(new RegExp(value, 'gi'), '') !== partnerName
      ));
      filteredPartnerName.forEach(({ partnerName, partnerNo }) => {
        const showName = partnerName.replace(new RegExp(value, 'gi'), '<span>$&</span>');
        const searchedPartnerInfo = {
          showName,
          targetName: partnerName,
          targetNo: partnerNo
        }        
        this.partnerResult = [...this.partnerResult, searchedPartnerInfo]
      });
    }
  }
  private clickPartner(partner: any) {
    this.showResult = false;
    this.selectedPartner = {
      targetName: partner.targetName,
      targetNo: partner.targetNo,
      couponTargetType: 'PARTNER'
    };
    this.partnerName = partner.targetName;
  }
  private partnerReset() {
    this.partnerResult = [];
    this.selectedPartner = null;
    this.partnerName = '';
  }
  private get notReadyEditFlg() {
    let disablFlg = false;
    if (this.partnerName === '') {
      disablFlg = true;
    }
    return disablFlg;
  }

  private closeResult() {
    this.showResult = false;
    this.partnerResult = [];
    this.selectedPartner = null;
  }
  private selectedBrand = {
    targetName: '',
    targetNo: '',
    couponTargetType: 'BRAND'
  } 

  private couponTypes = {
    name: 'coupontype',
    data: [
      {
        id: 'coupontype_PRODUCT',
        value: 'PRODUCT',
        dispaly: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_ON_PRODUCT_AMOUNT'
      },
      {
        id: 'coupontype_CART',
        value: 'CART',
        dispaly: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_ON_SHOPPING_CART_AMOUNT'
      }
    ]
  };

  // 회원유형
  private memberTypes = [
    /*{
      memberTypeValue: 'ALL',
      memberTypeName: 'STATISTIC_PROMOTION_ALL'
    },
    {
      memberTypeValue: 'MALL',
      memberTypeName: 'STATISTIC_PROMOTION_SHOPPING_MALL_MEMBERS'
    },
    {
      memberTypeValue: 'PAYCO',
      memberTypeName: 'STATISTIC_PROMOTION_PAYCO_ID_MEMBER'
    },
    {
      memberTypeValue: 'OPENID',
      memberTypeName: 'STATISTIC_PROMOTION_ABOUT_OPENID'
    },
    {
      memberTypeValue: 'NEOID',
      memberTypeName: 'STATISTIC_PROMOTION_INTEGRATED_MANAGEMENT_MEMBER'
    }*/
  ];
  // 회원등급
  private grades = [
    {
      memberGradeNoValue: 0,
      memberGradeNoName: 'STATISTIC_PROMOTION_ALL'
    }
  ];
  // 조회기간
  private dateType: string = 'PERIOD';
  private dateTypes = [
    {
      dateTypeValue: 'PERIOD',
      dateTypeName: 'STATISTIC_PROMOTION_BY_PERIOD'
    },
    {
      dateTypeValue: 'MONTH',
      dateTypeName: 'STATISTIC_PROMOTION_MONTHLY'
    }
  ];

  // 회원그룹
  private memberGroups = [
    {
      memberGroupNoValue: 0,
      memberGroupNoName: 'STATISTIC_PROMOTION_ALL'
    }
  ];
  // 클레임 구분
  private includesClaims = [
    {
      includesClaimValue: false,
      includesClaimName: 'STATISTIC_PROMOTION_INCLUDES_NO_CLAIMS'
    },
    {
      includesClaimValue: true,
      includesClaimName: 'STATISTIC_PROMOTION_CLAIM_INCLUDED'
    }
  ];
  // 프로모션 검색
  private promotionKeywordTypes = [
    {
      promotionKeywordTypeValue: 'NAME',
      promotionKeywordTypeName: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_COUPON_NAME'
    },
    {
      promotionKeywordTypeValue: 'NO',
      promotionKeywordTypeName: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_COUPON_NUMBER'
    },
    {
      promotionKeywordTypeValue: 'REGISTRANT',
      promotionKeywordTypeName: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_COUPON_REGISTER'
    }
  ];
  // 회원 성별
  private genderTypesCheckboxOptions = {
    name: 'genderTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: 'STATISTIC_PROMOTION_SELECT_ALL'
      },
      {
        id: 'MALE',
        value: 'MALE',
        dispaly: 'STATISTIC_PROMOTION_SELECT_MALE'
      },
      {
        id: 'FEMALE',
        value: 'FEMALE',
        dispaly: 'STATISTIC_PROMOTION_SELECT_FEMALE'
      },
      {
        id: 'UNKNOWN',
        value: 'UNKNOWN',
        dispaly: 'STATISTIC_PROMOTION_SELECT_UNKNOWN'
      }
    ]
  };

  private get issuableGenderTypes() {
    if (this.getStatisticsPromotionsCouponsRequest.params.genderTypes !== 'ALL') {
      return this.getStatisticsPromotionsCouponsRequest.params.genderTypes.split(',');
    } else {
      return (this.$refs.issuableGenderTypes as any).valueArr;
    }
  }
  // 플랫폼 구분
  private platformTypes = {
    name: 'platformTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: 'STATISTIC_PROMOTION_SELECT_ALL'
      },
      {
        id: 'PC',
        value: 'PC',
        dispaly: 'PC'
      },
      {
        id: 'MOBILE_WEB',
        value: 'MOBILE_WEB',
        dispaly: 'STATISTIC_PROMOTION_MOBILE_WEBSITE'
      },
      {
        id: 'MOBILE_APP',
        value: 'MOBILE_APP',
        dispaly: 'STATISTIC_PROMOTION_MOBILE_APP'
      }
    ]
  };

  private get issuablePlatformTypes() {
    if (this.getStatisticsPromotionsCouponsRequest.params.platformTypes !== 'ALL') {
      return this.getStatisticsPromotionsCouponsRequest.params.platformTypes.split(',');
    } else {
      return (this.$refs.issuablePlatform as any).valueArr;
    }
  }

  private year: number = new Date().getFullYear();
  private beginYear: number = new Date().getFullYear() - 5 >= 2017 ? new Date().getFullYear() - 5 : 2017;
  private get yearList() {
    const years = [];
    const todayYear = new Date().getFullYear();
    for (let i = this.beginYear; i <= todayYear; i++) {
      years.push({
        value: i,
        name: `${i}${this.$t('COMMON_YEAR')}`
      });
    }
    return years;
  }
  private month: number = new Date().getMonth() + 1;
  private get monthList() {
    const months = [];
    for (let i = 1; i <= 12; i++) {
      months.push({
        value: i,
        name: `${i}${this.$t('COMMON_MONTH')}`
      });
    }
    return months;
  }

  private startDate: string = addMonth(new Date(), -1);
  private endDate: string = getToday();
  private periodOption = {
    havePeriodBtn: true,
    dateType: 'Ymd',
    period: '1m',
    periodTypes: ['td', 'ytd', '1w', '1m']
  };

  private created() {
    const noData = this.$t('STATISTIC_SALES_PERIOD_INIT_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.summary1ProductGridProps = i18nInObjectList(this, this.summary1ProductGridProps, 'columns', 'header');
    this.summary2ProductGridProps.options.header = i18nInObjectList(this, this.summary2ProductGridProps.options.header, 'complexColumns', 'header');
    this.summary2ProductGridProps = i18nInObjectList(this, this.summary2ProductGridProps, 'columns', 'header');
    this.productGridResult = i18nInObjectList(this, this.productGridResult, 'columns', 'header');
    this.summary1CartGridProps = i18nInObjectList(this, this.summary1CartGridProps, 'columns', 'header');
    this.cartGridResult = i18nInObjectList(this, this.cartGridResult, 'columns', 'header');
    this.getStatisticsPromotionsCouponsRequest.params.mallNo = String(this.malls[0].mallNo);
    //this.getStatisticsPromotionsCouponsRequest.params.memberType = String(this.memberTypes[0].memberTypeValue);
    this.getStatisticsPromotionsCouponsRequest.params.includesClaim = String(this.includesClaims[0].includesClaimValue);
    this.getStatisticsPromotionsCouponsRequest.params.promotionKeywordType = String(this.promotionKeywordTypes[0].promotionKeywordTypeValue);
  }
  private getStatisticsPromotionsCouponsRequest: GetStatisticsPromotionsCouponsRequest = {
    params: {
      couponType: 'PRODUCT',
      displayBrandNo: '',
      endYmd: '',
      genderTypes: 'ALL',
      includesClaim: '',
      keyword: '',
      mallNo: String(this.malls && this.malls[0].mallNo),
      memberGradeNo: '',
      memberGroupNo: '',
      memberType: '',
      page: '1',
      partnerNo: '',
      platformTypes: 'ALL',
      promotionKeywordType: '',
      promotionType: 'COUPON',
      size: '30',
      startYmd: ''
    }
  };
  private async selectMall() {
    this.changeMall();
  }

  private async changeMall() {
    this.getMemberTypes();
    this.getGrades();
    this.getGroups();
  }

  private async mounted() {
    //console.log(this.cartGridResult);
    this.getMemberTypes();
    this.getGrades();
    this.getGroups();
    this.setIsNaverPayMall();
    //this.excelComprehensive();
    $('body').on('click', '.excelCoupon', $.proxy(this.excelCouponDown, this));
    $('body').on('click', '.excelCouponNo', $.proxy(this.excelCouponNoDown, this));
  }

  private searchAfterInfo: any = {};
  private searchAfterData() {
    this.searchAfterInfo.mallNo = this.getStatisticsPromotionsCouponsRequest.params.mallNo;
    this.searchAfterInfo.genderTypes = this.getStatisticsPromotionsCouponsRequest.params.genderTypes;
    this.searchAfterInfo.memberType = this.getStatisticsPromotionsCouponsRequest.params.memberType;
    this.searchAfterInfo.platformTypes = this.getStatisticsPromotionsCouponsRequest.params.platformTypes;
    this.searchAfterInfo.includesClaim = this.getStatisticsPromotionsCouponsRequest.params.includesClaim;
    this.searchAfterInfo.keyword = this.getStatisticsPromotionsCouponsRequest.params.keyword;
    this.searchAfterInfo.promotionKeywordType = this.getStatisticsPromotionsCouponsRequest.params.promotionKeywordType;
    this.searchAfterInfo.memberGradeNo = this.getStatisticsPromotionsCouponsRequest.params.memberGradeNo;
    this.searchAfterInfo.memberGroupNo = this.getStatisticsPromotionsCouponsRequest.params.memberGroupNo;
    this.searchAfterInfo.promotionType = this.getStatisticsPromotionsCouponsRequest.params.promotionType;
  }
  //private excelComprehensive() {
  //  let dateNow = new Date().getTime();
    private excelDownRequest = {
      params: {
        categoryDepth: '', //  要搜索的类别深度
        categoryNo: '', //  类别号
        couponType: '', //  优惠券类型
        displayBrandNo: '', //  展览品牌号
        displayCategoryNo: '', //  展览分类号
        endYmd: '', // *  结束日期
        genderTypes: '', // *  会员性别
        includesClaim: '', //  클레임구분
        keyword: '', //  검색어 입력
        mallNo: '', // * mall
        memberGradeNo: '', //  会员等级
        memberGroupNo: '', //  会员组
        memberType: '', // * 会员类型
        page: '', // * page
        partnerNo: '', //  파트너번호
        payType: '', //  支付手段
        platformTypes: '', // * 平台类型（pc web app）
        productNos: '', // 商品编号列表
        productType: '', //  商品查询标准
        promotionKeywordType: '', //  促销搜索关键字类型
        promotionType: '', //  宣传搜索类型
        saleMethodType: '', //  销售方式区分
        size: '', // * size
        startYmd: '', // *  开始日期
        discountNo: null,
        couponNo: null
      }
    };

   /* $('body').on('click', '.excelCoupon', () => {
      //console.log(1);
      excelDownRequest.params.mallNo = this.searchAfterInfo.mallNo ? this.searchAfterInfo.mallNo : this.getStatisticsPromotionsCouponsRequest.params.mallNo; // * mall
      excelDownRequest.params.endYmd = this.retEndYmd ? this.retEndYmd : this.startDate; // *  结束日期
      excelDownRequest.params.startYmd = this.retStartYmd ? this.retStartYmd : this.endDate; // *  开始日期
      excelDownRequest.params.genderTypes = this.searchAfterInfo.genderTypes ? this.searchAfterInfo.genderTypes : this.getStatisticsPromotionsCouponsRequest.params.genderTypes; // *  会员性别
      excelDownRequest.params.memberType = this.searchAfterInfo.memberType ? this.searchAfterInfo.memberType : this.getStatisticsPromotionsCouponsRequest.params.memberType; // * 会员类型
      excelDownRequest.params.platformTypes = this.searchAfterInfo.platformTypes ? this.searchAfterInfo.platformTypes : this.getStatisticsPromotionsCouponsRequest.params.platformTypes; // * 平台类型（pc web app）
      excelDownRequest.params.page = '1';
      excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.retPartnerName === '-' ? '' : this.retPartnerName; //  파트너번호
      excelDownRequest.params.displayBrandNo = this.retBrandName === '-' ? '' : this.retBrandName; //  展览品牌号
      excelDownRequest.params.includesClaim = this.searchAfterInfo.includesClaim ? this.searchAfterInfo.includesClaim : this.getStatisticsPromotionsCouponsRequest.params.includesClaim; //  클레임구분
      excelDownRequest.params.keyword = this.searchAfterInfo.keyword ? this.searchAfterInfo.keyword : this.getStatisticsPromotionsCouponsRequest.params.keyword; //  검색어 입력
      excelDownRequest.params.promotionKeywordType = this.searchAfterInfo.promotionKeywordType
        ? this.searchAfterInfo.promotionKeywordType
        : this.getStatisticsPromotionsCouponsRequest.params.promotionKeywordType; //  促销搜索关键字类型
      excelDownRequest.params.memberGradeNo = this.searchAfterInfo.memberGradeNo ? this.searchAfterInfo.memberGradeNo : this.getStatisticsPromotionsCouponsRequest.params.memberGradeNo; //  会员等级
      excelDownRequest.params.memberGroupNo = this.searchAfterInfo.memberGroupNo ? this.searchAfterInfo.memberGroupNo : this.getStatisticsPromotionsCouponsRequest.params.memberGroupNo; //  会员组
      excelDownRequest.params.promotionType = this.searchAfterInfo.promotionType ? this.searchAfterInfo.promotionType : this.getStatisticsPromotionsCouponsRequest.params.promotionType; //  宣传搜索类型
      excelDownRequest.params.couponType= this.getStatisticsPromotionsCouponsRequest.params.couponType;
      excelDownRequest.params.discountNo = null;
      const fileName = `Sales_Statistic_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}_${dateNow}.xlsx`;
      this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
        const blob = new window.Blob([res.data], {type: 'blob'});
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    });*/
    private excelCouponDown() {
    if (!this.genderTypeValidate()) return;
      //let dateNow = new Date().getTime();
      const excelDownRequest = {...this.excelDownRequest};
      excelDownRequest.params.couponNo = null;
      excelDownRequest.params.mallNo = this.searchAfterInfo.mallNo ? this.searchAfterInfo.mallNo : this.getStatisticsPromotionsCouponsRequest.params.mallNo; // * mall
      excelDownRequest.params.endYmd = this.retEndYmd ? this.retEndYmd : this.startDate; // *  结束日期
      excelDownRequest.params.startYmd = this.retStartYmd ? this.retStartYmd : this.endDate; // *  开始日期
      excelDownRequest.params.genderTypes = this.searchAfterInfo.genderTypes ? this.searchAfterInfo.genderTypes : this.getStatisticsPromotionsCouponsRequest.params.genderTypes; // *  会员性别
      excelDownRequest.params.memberType = this.searchAfterInfo.memberType ? this.searchAfterInfo.memberType : this.getStatisticsPromotionsCouponsRequest.params.memberType; // * 会员类型
      excelDownRequest.params.platformTypes = this.searchAfterInfo.platformTypes ? this.searchAfterInfo.platformTypes : this.getStatisticsPromotionsCouponsRequest.params.platformTypes; // * 平台类型（pc web app）
      excelDownRequest.params.page = '1';
      //excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.retPartnerNo === '-' ? '' : this.retPartnerNo; //  파트너번호
      excelDownRequest.params.displayBrandNo = this.retBrandName === '-' ? '' : this.retBrandName; //  展览品牌号
      excelDownRequest.params.includesClaim = this.searchAfterInfo.includesClaim ? this.searchAfterInfo.includesClaim : this.getStatisticsPromotionsCouponsRequest.params.includesClaim; //  클레임구분
      excelDownRequest.params.keyword = this.searchAfterInfo.keyword ? this.searchAfterInfo.keyword : this.getStatisticsPromotionsCouponsRequest.params.keyword; //  검색어 입력
      excelDownRequest.params.promotionKeywordType = this.searchAfterInfo.promotionKeywordType
        ? this.searchAfterInfo.promotionKeywordType
        : this.getStatisticsPromotionsCouponsRequest.params.promotionKeywordType; //  促销搜索关键字类型
      excelDownRequest.params.memberGradeNo = this.searchAfterInfo.memberGradeNo ? this.searchAfterInfo.memberGradeNo : this.getStatisticsPromotionsCouponsRequest.params.memberGradeNo; //  会员等级
      excelDownRequest.params.memberGroupNo = this.searchAfterInfo.memberGroupNo ? this.searchAfterInfo.memberGroupNo : this.getStatisticsPromotionsCouponsRequest.params.memberGroupNo; //  会员组
      excelDownRequest.params.promotionType = this.searchAfterInfo.promotionType ? this.searchAfterInfo.promotionType : this.getStatisticsPromotionsCouponsRequest.params.promotionType; //  宣传搜索类型
      excelDownRequest.params.couponType= this.getStatisticsPromotionsCouponsRequest.params.couponType;
      excelDownRequest.params.discountNo = null;
      const hasData = excelDownRequest.params.couponType ==='PRODUCT'? this.productCouponsContents.length > 0 : this.cartCouponsContents.length > 0;
      const period = `${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}`;
      createExcel(this,hasData, excelDownRequest.params, 'PREMIUM_STATISTICS_PROMOTION_COUPON', period)

      /*const fileName = `Sales_Statistic_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}_${dateNow}.xlsx`;
      this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
        const blob = new window.Blob([res.data], {type: 'blob'});
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });*/
    }

   /* $('body').on('click', '.excelCouponNo', (e) => {
      //dateNow = new Date().getTime();
      excelDownRequest.params.mallNo = this.searchAfterInfo.mallNo ? this.searchAfterInfo.mallNo : this.getStatisticsPromotionsCouponsRequest.params.mallNo; // * mall
      excelDownRequest.params.endYmd = this.retEndYmd ? this.retEndYmd : this.startDate; // *  结束日期
      excelDownRequest.params.startYmd = this.retStartYmd ? this.retStartYmd : this.endDate; // *  开始日期
      excelDownRequest.params.genderTypes = this.searchAfterInfo.genderTypes ? this.searchAfterInfo.genderTypes : this.getStatisticsPromotionsCouponsRequest.params.genderTypes; // *  会员性别
      excelDownRequest.params.memberType = this.searchAfterInfo.memberType ? this.searchAfterInfo.memberType : this.getStatisticsPromotionsCouponsRequest.params.memberType; // * 会员类型
      excelDownRequest.params.platformTypes = this.searchAfterInfo.platformTypes ? this.searchAfterInfo.platformTypes : this.getStatisticsPromotionsCouponsRequest.params.platformTypes; // * 平台类型（pc web app）
      excelDownRequest.params.page = '1';
      excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.retPartnerName === '-' ? '' : this.retPartnerName; //  파트너번호
      excelDownRequest.params.displayBrandNo = this.retBrandName === '-' ? '' : this.retBrandName; //  展览品牌号
      excelDownRequest.params.includesClaim = this.searchAfterInfo.includesClaim ? this.searchAfterInfo.includesClaim : this.getStatisticsPromotionsCouponsRequest.params.includesClaim; //  클레임구분
      excelDownRequest.params.keyword = this.searchAfterInfo.keyword ? this.searchAfterInfo.keyword : this.getStatisticsPromotionsCouponsRequest.params.keyword; //  검색어 입력
      excelDownRequest.params.promotionKeywordType = this.searchAfterInfo.promotionKeywordType
        ? this.searchAfterInfo.promotionKeywordType
        : this.getStatisticsPromotionsCouponsRequest.params.promotionKeywordType; //  促销搜索关键字类型
      excelDownRequest.params.memberGradeNo = this.searchAfterInfo.memberGradeNo ? this.searchAfterInfo.memberGradeNo : this.getStatisticsPromotionsCouponsRequest.params.memberGradeNo; //  会员等级
      excelDownRequest.params.memberGroupNo = this.searchAfterInfo.memberGroupNo ? this.searchAfterInfo.memberGroupNo : this.getStatisticsPromotionsCouponsRequest.params.memberGroupNo; //  会员组
      excelDownRequest.params.promotionType = this.searchAfterInfo.promotionType ? this.searchAfterInfo.promotionType : this.getStatisticsPromotionsCouponsRequest.params.promotionType; //  宣传搜索类型
      excelDownRequest.params.couponNo = e.currentTarget.attributes[3].value;
      excelDownRequest.params.couponType= this.getStatisticsPromotionsCouponsRequest.params.couponType;
      excelDownRequest.params.size = this.getStatisticsPromotionsCouponsRequest.params.size;
      excelDownRequest.params.page = this.getStatisticsPromotionsCouponsRequest.params.page;

      const fileName = `Sales_Statistic_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}_${dateNow}.xlsx`;
      this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
        const blob = new window.Blob([res.data], {type: 'blob'});
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    });
  }*/
  private excelCouponNoDown(e: any) {
    if (!this.genderTypeValidate()) return;
     //let dateNow = new Date().getTime();
     const excelDownRequest = {...this.excelDownRequest};
      excelDownRequest.params.mallNo = this.searchAfterInfo.mallNo ? this.searchAfterInfo.mallNo : this.getStatisticsPromotionsCouponsRequest.params.mallNo; // * mall
      excelDownRequest.params.endYmd = this.retEndYmd ? this.retEndYmd : this.startDate; // *  结束日期
      excelDownRequest.params.startYmd = this.retStartYmd ? this.retStartYmd : this.endDate; // *  开始日期
      excelDownRequest.params.genderTypes = this.searchAfterInfo.genderTypes ? this.searchAfterInfo.genderTypes : this.getStatisticsPromotionsCouponsRequest.params.genderTypes; // *  会员性别
      excelDownRequest.params.memberType = this.searchAfterInfo.memberType ? this.searchAfterInfo.memberType : this.getStatisticsPromotionsCouponsRequest.params.memberType; // * 会员类型
      excelDownRequest.params.platformTypes = this.searchAfterInfo.platformTypes ? this.searchAfterInfo.platformTypes : this.getStatisticsPromotionsCouponsRequest.params.platformTypes; // * 平台类型（pc web app）
      excelDownRequest.params.page = '1';
      //excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.retPartnerNo === '-' ? '' : this.retPartnerNo; //  파트너번호
      excelDownRequest.params.displayBrandNo = this.retBrandName === '-' ? '' : this.retBrandName; //  展览品牌号
      excelDownRequest.params.includesClaim = this.searchAfterInfo.includesClaim ? this.searchAfterInfo.includesClaim : this.getStatisticsPromotionsCouponsRequest.params.includesClaim; //  클레임구분
      excelDownRequest.params.keyword = this.searchAfterInfo.keyword ? this.searchAfterInfo.keyword : this.getStatisticsPromotionsCouponsRequest.params.keyword; //  검색어 입력
      excelDownRequest.params.promotionKeywordType = this.searchAfterInfo.promotionKeywordType
        ? this.searchAfterInfo.promotionKeywordType
        : this.getStatisticsPromotionsCouponsRequest.params.promotionKeywordType; //  促销搜索关键字类型
      excelDownRequest.params.memberGradeNo = this.searchAfterInfo.memberGradeNo ? this.searchAfterInfo.memberGradeNo : this.getStatisticsPromotionsCouponsRequest.params.memberGradeNo; //  会员等级
      excelDownRequest.params.memberGroupNo = this.searchAfterInfo.memberGroupNo ? this.searchAfterInfo.memberGroupNo : this.getStatisticsPromotionsCouponsRequest.params.memberGroupNo; //  会员组
      excelDownRequest.params.promotionType = this.searchAfterInfo.promotionType ? this.searchAfterInfo.promotionType : this.getStatisticsPromotionsCouponsRequest.params.promotionType; //  宣传搜索类型
      //excelDownRequest.params.couponNo = e.currentTarget.attributes[3].value;
      excelDownRequest.params.couponNo =$(e.target).data('couponno');
      excelDownRequest.params.couponType= this.getStatisticsPromotionsCouponsRequest.params.couponType;
      //excelDownRequest.params.size = this.getStatisticsPromotionsCouponsRequest.params.size;
      excelDownRequest.params.page = this.getStatisticsPromotionsCouponsRequest.params.page;

      const hasData = excelDownRequest.params.couponType ==='PRODUCT'? this.productCouponsContents.length > 0 : this.cartCouponsContents.length > 0;
      const couponPeriod = `${excelDownRequest.params.couponNo}_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}`;
      createExcel(this, hasData, excelDownRequest.params, 'PREMIUM_STATISTICS_PROMOTION_COUPON_DETAIL', couponPeriod);

      /*const fileName = `Sales_Statistic_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}_${dateNow}.xlsx`;
      this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
        const blob = new window.Blob([res.data], {type: 'blob'});
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });*/
  }
  private setIsNaverPayMall() {
    this.malls.forEach((mallInfo: Mall) => {
      let naverPayMall = false;
      const orderConfigRequest = {
        pathParams: {
          mallNo: String(mallInfo.mallNo)
        },
        params: {
          key: 'ORDER_CONFIG' // 결제수단 조회
        }
      };
      this.$api.getMallsConfigurations(orderConfigRequest).then((ret) => {
        if (ret && ret.data) {
          naverPayMall = ret.data.useNaverPay;
          if (naverPayMall) {
            this.useNaverPay = naverPayMall;
            return;
          }
        }
      });
    });
  }

    private async getMemberTypes() {
     $('#loading').show();
     this.memberTypes=[];
     const mallNo = this.getStatisticsPromotionsCouponsRequest.params.mallNo;
     const ret = await this.$api.getStatisticsMemberTypes({params: {mallNo: mallNo.toString()}});
     ret.data.forEach((item) => {
        this.memberTypes.push({
          memberTypeValue: item.type,
          memberTypeName: item.label
        })
      });
      this.getStatisticsPromotionsCouponsRequest.params.memberType = this.memberTypes[0].memberTypeValue;
      $('#loading').hide();
  }

  private async getGrades() {
    $('#loading').show();
    this.grades = [
      {
        memberGradeNoValue: 0,
        memberGradeNoName: 'STATISTIC_PROMOTION_ALL'
      }
    ];
    const mallNo = this.getStatisticsPromotionsCouponsRequest.params.mallNo;
    const memberGradeList = await this.$api.getMemberGrades({params: {mallNo: Number(mallNo)}});
    const sortGrade = await memberGradeList.data.sort((a: Grade, b: Grade) => a.order - b.order);
    if (sortGrade && sortGrade.length) {
      const resGrade = sortGrade.filter(item => item.used);
      resGrade.forEach((grade: Grade) => {
        this.grades.push({
          memberGradeNoValue: grade.no,
          memberGradeNoName: grade.name
        });
      });
    }
    this.getStatisticsPromotionsCouponsRequest.params.memberGradeNo = String(this.grades[0].memberGradeNoValue);
    $('#loading').hide();
    return this.grades;
  }

  private async getGroups() {
    $('#loading').show();
    this.memberGroups = [
      {
        memberGroupNoValue: 0,
        memberGroupNoName: 'STATISTIC_PROMOTION_ALL'
      },
      {
        memberGroupNoValue: -1,
        memberGroupNoName: 'STATISTIC_SALES_PERIOD_GROUP_NOT_SET'
      }
    ];
    const mallNo = this.getStatisticsPromotionsCouponsRequest.params.mallNo;
    const memberGroupList = await this.$api.getMemberGroups({params: {mallNo: Number(mallNo)}});
    const sortGroup = await memberGroupList.data.sort((a: Group, b: Group) => b.order - a.order);
    if (sortGroup && sortGroup.length) {
      sortGroup.forEach((group: Group) => {
        this.memberGroups.push({
          memberGroupNoValue: group.no,
          memberGroupNoName: group.name
        });
      });
    }
    this.getStatisticsPromotionsCouponsRequest.params.memberGroupNo = String(this.memberGroups[0].memberGroupNoValue);
    $('#loading').hide();
    return this.memberGroups;
  }
  private size: number = 30;
  private cartSize: number =30;
  private genderTypeValidate(): boolean {
    if (this.issuableGenderTypes.join(',') === '') {
      alert(this.$t('VERIFY_MESSAGE_GENDER'));
      return false;
    }
    return true;
  }
  // 조회
  private async search(page: number = 1, size: number) {
    if (!this.genderTypeValidate()) return;
    const noData = this.$t('STATISTIC_SALES_PERIOD_SEARCH_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    // 判断size是否改变，改变重新赋值size，page
    if (size) {
      this.getStatisticsPromotionsCouponsRequest.params.size = String(size);
      this.getStatisticsPromotionsCouponsRequest.params.page = String(page);
         if (this.getStatisticsPromotionsCouponsRequest.params.couponType === 'CART') {
            this.cartSize = size;
         } else {
            this.size = size;
         }
    } else {
      // size没改变（默认值undefined）重新赋值page， size使用初始化定义的值
      this.getStatisticsPromotionsCouponsRequest.params.page = String(page);
    }

   if (this.getStatisticsPromotionsCouponsRequest.params.couponType === 'CART') {
    this.cartGridResult.options.pageOptions.page = page;
    this.cartGridResult.options.pageOptions.perPage = this.cartSize;
   }  else {
    this.productGridResult.options.pageOptions.page = page;
    this.productGridResult.options.pageOptions.perPage = this.size;
   }

    Object.assign(this.getStatisticsPromotionsCouponsRequest.params, {page});
    let startDateTime = '';
    let endDateTime = '';
    if (this.dateType === 'MONTH') {
      const tempDates = getFirstAndEndDay(this.year, this.month);
      startDateTime = tempDates.startYmd;
      endDateTime = tempDates.endYmd;
    } else if (this.dateType === 'PERIOD') {
      startDateTime = (this.$refs.combinedPeriod as any).startYmdt;
      endDateTime = (this.$refs.combinedPeriod as any).endYmdt;
    }
    this.getStatisticsPromotionsCouponsRequest.params.startYmd = startDateTime;
    this.getStatisticsPromotionsCouponsRequest.params.endYmd = endDateTime;
    let mallName = '';
    this.malls.forEach((mallInfo: Mall) => {
      if (mallInfo.mallNo === Number(this.getStatisticsPromotionsCouponsRequest.params.mallNo)) {
        mallName = mallInfo.mallName;
        return;
      }
    });

    this.getStatisticsPromotionsCouponsRequest.params.genderTypes = this.issuableGenderTypes.join(',');
    this.getStatisticsPromotionsCouponsRequest.params.platformTypes = this.issuablePlatformTypes.join(',');
    this.getStatisticsPromotionsCouponsRequest.params.displayBrandNo = this.selectedBrand?.targetNo ? this.selectedBrand.targetNo : '';
    this.getStatisticsPromotionsCouponsRequest.params.partnerNo = this.selectedPartner ? this.selectedPartner.targetNo : '';
    $('#loading').show();
    if (this.getStatisticsPromotionsCouponsRequest.params.couponType === 'PRODUCT') {
      this.displayGrid = false;
      await this.$api
        .getStatisticsPromotionsProductCouponsSummary(this.getStatisticsPromotionsCouponsRequest)
        .then((ret) => {
          const {data} = ret;
          if (this.dateType === 'PERIOD' && data.startYmd) {
            this.retStartYmd = data.startYmd;
            this.retEndYmd = data.endYmd;
            this.retDateType = 'PERIOD';
          } else if (this.dateType === 'MONTH' && data.startYmd) {
            const dataArray = data.startYmd.split('-');
            this.retYear = dataArray[0];
            this.retMonth = dataArray[1];
            this.retDateType = 'MONTH';
            this.retStartYmd = data.startYmd;
            this.retEndYmd = data.endYmd;
          }

          this.productCouponsSummary = [
            {
              totalOrderCnt: data.summary.totalOrderCnt,
              totalProductCnt: data.summary.totalProductCnt,
              totalSaleCnt: data.summary.totalSaleCnt,
              totalSaleAmt: data.summary.totalSaleAmt,
              totalProductCouponAmt: data.summary.totalProductCouponAmt,
              totalBuyPrice: data.summary.totalSaleAmt - data.summary.totalProductCouponAmt,
              totalCouponAmt: data.summary.totalCouponAmt,
              productCouponPer: this.getPer(data.summary.totalProductCouponAmt, data.summary.totalCouponAmt),
              firstHeader: `${window.$t('STATISTIC_PROMOTION_COUPON_COMMODITY_DISCOUNT')}`,
              totalMallAmt: data.summary.totalMallCouponAmt,
              totalMallPer: this.getBurdenRatio(data.summary.totalMallCouponAmt, data.summary.totalPartnerCouponAmt).mall,
              totalPartnerAmt: data.summary.totalPartnerCouponAmt,
              totalPartnerPer: this.getBurdenRatio(data.summary.totalMallCouponAmt, data.summary.totalPartnerCouponAmt).partner,
              currencyCode: data.currencyCode
            }
          ];

          this.retPartnerName = this.getSearchData(this.selectedPartner ? this.selectedPartner.targetName : '');
          this.retPartnerNo = this.getSearchData(this.selectedPartner ? this.selectedPartner.targetNo : '');
          this.retBrandName = this.getSearchData(this.selectedBrand?.targetName ? this.selectedBrand.targetName : '');
          this.retMallName = mallName;
        })
        .finally((): any => {
          $('#loading').hide();
        });

      await this.$api
        .getStatisticsPromotionsProductCoupons(this.getStatisticsPromotionsCouponsRequest)
        .then((ret) => {
          const {data} = ret;
          this.productCouponsContents = data.contents.map((contentitem) => {
            return {...contentitem, mallName: mallName};
          });
          this.totalCount = data.totalCount;
        })
        .finally((): any => {
          $('#loading').hide();
        });
    } else if (this.getStatisticsPromotionsCouponsRequest.params.couponType === 'CART') {
      this.displayGrid = true;
      await this.$api
        .getStatisticsPromotionsCartCouponsSummary(this.getStatisticsPromotionsCouponsRequest)
        .then((ret) => {
          const {data} = ret;
          if (this.dateType === 'PERIOD' && data.startYmd) {
            this.retStartYmd = data.startYmd;
            this.retEndYmd = data.endYmd;
            this.retDateType = 'PERIOD';
          } else if (this.dateType === 'MONTH' && data.startYmd) {
            const dataArray = data.startYmd.split('-');
            this.retYear = dataArray[0];
            this.retMonth = dataArray[1];
            this.retDateType = 'MONTH';
          }
          this.cartCouponsSummary = [
            {
              totalNumberOfOrders: data.summary.totalOrderCnt,
              totalCartCouponAmt: data.summary.totalCartCouponAmt,
              totalCouponAmt: data.summary.totalCouponAmt,
              cartCouponPer: this.getPer(data.summary.totalCartCouponAmt, data.summary.totalCouponAmt),
              totalPayAmt: data.summary.totalPayAmt
            }
          ];
          this.retPartnerName = this.getSearchData(this.selectedPartner.targetName);
          this.retPartnerNo = this.getSearchData(this.selectedPartner.targetNo);
          this.retBrandName = this.getSearchData(this.selectedBrand.targetName);
          this.retMallName = mallName;
        })
        .finally((): any => {
          $('#loading').hide();
        });

      await this.$api
        .getStatisticsPromotionsCartCoupons(this.getStatisticsPromotionsCouponsRequest)
        .then((ret) => {
          //console.log(ret);
          const {data} = ret;
          this.cartCouponsContents = data.contents.map((contentitem: any) => {
            return {...contentitem, mallName: mallName};
          });
          this.totalCount = data.totalCount;
        })
        .finally((): any => {
          $('#loading').hide();
        });
    }
  }

  private getSearchData(value: string) {
    return value === '' || value === undefined ? '-' : value;
  }

  private getPer(discountAmt: number, totalDiscountPrice: number) {
    let per = 0;
    if (totalDiscountPrice === 0) {
      return per;
    }
    per = (discountAmt / totalDiscountPrice) * 100;

    if (per === parseInt(per.toString())) {
      return per;
    }

    return per.toFixed(2);
  }

  private getBurdenRatio(mallAmt: number, partnerAmt: number) {
    let totalMallBurdenPer = 0;
    let totalPartnerBurdenPer = 0;
    if (mallAmt === 0 && partnerAmt === 0) {
      totalMallBurdenPer = 0;
      totalPartnerBurdenPer = 0;
    } else if (mallAmt === 0) {
      totalPartnerBurdenPer = 100;
    } else if (partnerAmt === 0) {
      totalMallBurdenPer = 100;
    } else {
      const allAmt = mallAmt + partnerAmt;
      totalMallBurdenPer = Number(((mallAmt / allAmt) * 100).toFixed(2));
      totalPartnerBurdenPer = Number(((partnerAmt / allAmt) * 100).toFixed(2));
    }

    return {mall: totalMallBurdenPer, partner: totalPartnerBurdenPer};
  }

  /** 화폐단위 추가 */
  private addCurrencyCode({ value, currencyCode = 'KRW' }: { value: any, currencyCode?: string}) {
    const formatValue = formatCurrency(value);

    return `${formatValue} ${currencyCode === 'KRW' ? '원' : currencyCode}`;
  }

  // 초기화
  private reset() {
    this.getStatisticsPromotionsCouponsRequest.params.mallNo = String(this.malls[0].mallNo);
    this.getStatisticsPromotionsCouponsRequest.params.memberType = String(this.memberTypes[0].memberTypeValue);
    this.getStatisticsPromotionsCouponsRequest.params.includesClaim = String(this.includesClaims[0].includesClaimValue);
    this.getStatisticsPromotionsCouponsRequest.params.promotionKeywordType = String(this.promotionKeywordTypes[0].promotionKeywordTypeValue);
    this.getGrades();
    this.getGroups();
    this.getStatisticsPromotionsCouponsRequest.params.couponType = 'PRODUCT';
    this.dateType = 'PERIOD';
    this.startDate = addMonth(new Date(), -1);
    this.endDate = getToday();
    (this.$refs.combinedPeriod as any).clickPeriod('1m');
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
    this.getStatisticsPromotionsCouponsRequest.params.keyword = '';
    this.getStatisticsPromotionsCouponsRequest.params.genderTypes = 'ALL';
    (this.$refs.issuableGenderTypes as any).setValues('ALL', 'MALE', 'FEMALE', 'UNKNOWN');
    this.getStatisticsPromotionsCouponsRequest.params.platformTypes = 'ALL';
    (this.$refs.issuablePlatform as any).setValues('ALL', 'PC', 'MOBILE_WEB', 'MOBILE_APP');
    this.partnerName = '';
    this.selectedBrand = {
      targetName: '',
      targetNo: '',
      couponTargetType: 'BRAND'
    };
    this.selectedPartner = {
      targetName: '',
      targetNo: '',
      couponTargetType: 'PARTNER'
    };
    (this.$refs.brandSearcherRef as BrandSearcher)?.resetBrand();
  }

  // 추가할인 판매현황 종합
  summary1ProductGridProps = {
    header: {
      height: 40,
      columns: [
        {
          name: 'totalBuyPrice',
          renderer: ({columnInfo}: any): any => {
            const div = document.createElement('div');
            div.innerHTML = columnInfo.header.split('@').join('<br>');
            return {
              getElement(): any {
                return div;
              },
              render(): void {}
            };
          }
        },
        {
          name: 'productCouponPer',
          renderer: ({columnInfo}: any): any => {
            const div = document.createElement('div');
            div.innerHTML = columnInfo.header.split('@').join('<br>');
            return {
              getElement(): any {
                return div;
              },
              render(): void {}
            };
          }
        }
      ]
    },
    columns: [
      {
        header: 'STATISTIC_PROMOTION_NUMBER_OF_SALES_HEADER',
        name: 'totalOrderCnt',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'STATISTIC_PROMOTION_NUMBER_OF_PRODUCTS_SOLD',
        name: 'totalProductCnt',
        minWidth: 100,
        align: 'center'
      },
      {
        header: 'STATISTIC_PROMOTION_SALES_QUANTITY',
        name: 'totalSaleCnt',
        minWidth: 100,
        align: 'center'
      },
      {
        header: 'STATISTIC_PROMOTION_SALES_AMOUNT_A',
        name: 'totalSaleAmt',
        minWidth: 148,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_TOTALPRODUCTCOUPONAMT',
        name: 'totalProductCouponAmt',
        minWidth: 148,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_PRODUCT_SALES_AMOUNT_C',
        name: 'totalBuyPrice',
        minWidth: 148,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_TOTAL_DISCOUNT_COUPON_AMOUNT_D',
        name: 'totalCouponAmt',
        minWidth: 148,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_PRODUCT_PRICE_DISCOUNT_RATE_E',
        name: 'productCouponPer',
        minWidth: 148,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_VIEW_DETAILS',
        name: 'excelBtn',
        width: 147,
        align: 'center',
        formatter: function (rowData: any) {
          return `<button type="button" class="excelBtn excelCoupon" data-mall-no="${rowData.mallNo}" ></span>${window.$t('STATISTIC_PROMOTION_DOWNLOAD')}</button>`;
        }
      }
    ],
    options: {
      columnOptions: {
        resizable: true
      },
      minBodyHeight: 33,
      rowHeight: 33,
      minRowHeight: 33,
      isInitialRequest: true,
      useClientSort: false,
      scrollX: false,
      scrollY: false,
      pageOptions: {}
    }
  };
  summary2ProductGridProps = {
    columns: [
      {
        header: 'STATISTIC_PROMOTION_DIVISION',
        name: 'firstHeader',
        align: 'center',
        minWidth: 198
      },
      {
        header: 'STATISTIC_PROMOTION_TOTAL_DISCOUNT_AMOUNT',
        name: 'totalProductCouponAmt',
        minWidth: 198,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_DISCOUNT_AMOUNT',
        name: 'totalMallAmt',
        minWidth: 198,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_RATIO',
        name: 'totalMallPer',
        minWidth: 198,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_DISCOUNT_AMOUNT',
        name: 'totalPartnerAmt',
        minWidth: 198,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_RATIO',
        name: 'totalPartnerPer',
        minWidth: 197,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      }
    ],
    options: {
      columnOptions: {
        resizable: true
      },
      header: {
        height: 66,
        complexColumns: [
          {
            header: 'STATISTIC_PROMOTION_SHOPPING_MALL_BURDEN',
            name: 'mergeMall',
            childNames: ['totalMallAmt', 'totalMallPer']
          },
          {
            header: 'STATISTIC_PROMOTION_PARTNER_BURDEN',
            name: 'mergePartner',
            childNames: ['totalPartnerAmt', 'totalPartnerPer']
          }
        ]
      },
      isInitialRequest: true,
      useClientSort: false,
      scrollX: false,
      scrollY: false,
      minRowHeight: 32,
      rowHeight: 32,
      bodyHeight: 32,
      minBodyHeight: 32
    }
  };
  productGridResult = {
    header: {
      height: 65,
      columns: [
        {
          name: 'buyPrice',
          renderer: ({columnInfo}: any): any => {
            const div = document.createElement('div');
            div.innerHTML = columnInfo.header.split('@').join('<br>');
            return {
              getElement(): any {
                return div;
              },
              render(): void {}
            };
          }
        }
      ]
    },
    columns: [
      {
        header: 'STATISTIC_PROMOTION_SHOPPING_MALL',
        name: 'mallName',
        align: 'center',
        width: 200
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_COUPON_NUMBER',
        name: 'couponNo',
        width: 100,
        align: 'center'
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_COUPON_NAME',
        name: 'couponName',
        width: 200,
        align: 'center'
      },
      {
        header: 'STATISTIC_PROMOTION_NUMBER_OF_SALES_HEADER',
        name: 'orderCnt',
        width: 80,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_SALES_QUANTITY',
        name: 'saleCnt',
        width: 80,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_SALES_AMOUNT_A',
        name: 'saleAmt',
        width: 150,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_PRODUCT_AMOUNT_DISCOUNT_SHOPPING_MALL_B1',
        name: 'mallProductCouponAmt',
        width: 190,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_PRODUCT_AMOUNT_DISCOUNT_PARTNER_B2',
        name: 'partnerProductCouponAmt',
        width: 200,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_PRODUCT_SALES_AMOUNT_BUYPRICE',
        name: 'buyPrice',
        width: 220,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_PROMOTION_VIEW_DETAILS',
        name: 'excelBtn',
        width: 100,
        align: 'center',
        formatter: function (rowData: any) {
          return `<button type="button" class="excelBtn excelCouponNo" data-mall-no="${rowData.mallNo}" data-couponNo="${rowData.row.couponNo}" ></span>${window.$t('STATISTIC_PROMOTION_DOWNLOAD')}</button>`;
        }
      }
    ],
    options: {
      columnOptions: {
        minWidth: 10,
        resizable: true
      },
      bodyHeight: 600,
      displayRowCount: 15,
      rowHeight: 35,
      minRowHeight: 35,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        page: 1,
        perPage: 30,
        totalCount: 0
      }
    }
  };
  summary1CartGridProps = {
    header: {
      height: 40,
      columns: [
        {
          name: 'cartCouponPer',
          renderer: ({columnInfo}: any): any => {
            const div = document.createElement('div');
            div.innerHTML = columnInfo.header.split('@').join('<br>');
            return {
              getElement(): any {
                return div;
              },
              render(): void {}
            };
          }
        }
      ]
    },
    columns: [
      {
        header: 'STATISTIC_PROMOTION_NUMBER_OF_SALES_HEADER',
        name: 'totalNumberOfOrders',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_SHOPPING_CART_DISCOUNT_B',
        name: 'totalCartCouponAmt',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_TOTAL_DISCOUNT_COUPON_AMOUNT_D',
        name: 'totalCouponAmt',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_RATE_OF_SHOPPING_CART_AMOUNT_E',
        name: 'cartCouponPer',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_TOTAL_PAYMENT_AMOUNT',
        name: 'totalPayAmt',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_VIEW_DETAILS',
        name: 'excelBtn',
        width: 195,
        align: 'center',
        formatter: function (rowData: any) {
          //console.log(rowData);
          return `<button type="button" class="excelBtn excelCoupon" data-mall-no="${rowData.mallNo}" ></span>${window.$t('STATISTIC_PROMOTION_DOWNLOAD')}</button>`;
        }
      }
    ],
    options: {
      columnOptions: {
        minWidth: 10,
        resizable: true
      },
      minBodyHeight: 33,
      rowHeight: 35,
      minRowHeight: 35,
      isInitialRequest: true,
      useClientSort: false,
      scrollX: false,
      scrollY: false
    }
  };
  cartGridResult = {
    header: {
      height: 65
    },
    columns: [
      {
        header: 'STATISTIC_PROMOTION_SHOPPING_MALL',
        name: 'mallName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_COUPON_NUMBER',
        name: 'couponNo',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_COUPON_NAME',
        name: 'couponName',
        align: 'center',
        minWidth: 140
      },
      {
        header: 'STATISTIC_PROMOTION_NUMBER_OF_SALES_HEADER',
        name: 'orderCnt',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_DISCOUNT_ON_SHOPPING_CART_AMOUNT',
        name: 'cartCouponAmt',
        width: 220,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_COUPON_TOTAL_PAYMENT_AMOUNT',
        name: 'payAmt',
        width: 220,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_VIEW_DETAILS',
        name: 'excelBtn',
        width: 100,
        align: 'center',
        formatter: function (rowData: any) {
          return `<button type="button" class="excelBtn excelCouponNo" data-mall-no="${rowData.mallNo}" data-couponNo="${rowData.row.couponNo}" ></span>${window.$t(
            'STATISTIC_PROMOTION_DOWNLOAD'
          )}</button>`;
        }
      }
    ],
    options: {
      columnOptions: {
        minWidth: 10,
        resizable: true
      },
      displayRowCount: 15,
      rowHeight: 35,
      minRowHeight: 35,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        page: 1,
        perPage: 30,
        totalCount: 0
      }
    }
  };

  private goPage(url: string) {
    if (this.$route.path === url) {
      this.$router.go(0);
      return;
    }
    this.$router.push({path: url});
  }
  private replaceFileNm(fileName:string) {
    let fileNm = '';
    if (fileName){
      fileNm = fileName.replaceAll('-','');
    }
    return fileNm;
  }
  protected beforeDestroy(): void {
    $('body').off('click', '.excelCoupon', $.proxy(this.excelCouponDown, this));
    $('body').off('click', '.excelCouponNo', $.proxy(this.excelCouponNoDown, this));
    //$('body').off('click', '.excelCouponNo');
    //$('body').off('click', '.excelCoupon');
  }
}
